"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var customDateRange_styles_1 = require("./customDateRange.styles");
var core_components_1 = require("@securityproducts/core-components");
var dateAndTime_1 = require("./dateAndTime");
var displayDataBy_1 = require("./displayDataBy");
var dateRangeValidator_1 = require("../../../../util/validation/dateRangeValidator");
var luxon_1 = require("luxon");
var customDateRange_i18n_1 = require("./customDateRange.i18n");
function CustomDateRange(props) {
    var _a = React.useState(false), resetTime = _a[0], setResetTime = _a[1];
    var firstRun = React.useRef(true);
    var inputStart = React.useRef(null);
    var inputEnd = React.useRef(null);
    var _b = React.useState([]), allowedActions = _b[0], setAllowedActions = _b[1];
    var _c = React.useState(props.from), from = _c[0], setFrom = _c[1];
    var _d = React.useState(props.to), to = _d[0], setTo = _d[1];
    var strings = core_components_1.useLocalisation(customDateRange_i18n_1.customDateRangeTranslations, props.language);
    var _e = React.useState(props.display || "HOURS"), displayLocal = _e[0], setDisplayLocal = _e[1];
    var _f = React.useState(null), validationReason = _f[0], setValidationReason = _f[1];
    function isValid() {
        if (dateRangeValidator_1.dateIsAfter(from, to)) {
            setValidationReason(strings.after);
            return false;
        }
        else if (dateRangeValidator_1.dateIsExactSameIgnoringMillis(from, to)) {
            setValidationReason(strings.sameAs);
            return false;
        }
        else {
            setValidationReason(null);
            return true;
        }
    }
    function applyRangeLegacy() {
        props.setArchiveMode(false);
        props.setRange({ fromDate: from, toDate: to });
        props.setDisplay(displayLocal);
        props.setCurrentRange("Custom");
        setTimeout(function () { return props.closePicker(); }, 0);
    }
    function applyRange() {
        if (isValid()) {
            if (props.applyRangeAtomically) {
                props.applyRangeAtomically(displayLocal, { fromDate: from, toDate: to });
            }
            else {
                applyRangeLegacy();
            }
        }
    }
    var enableTime = canSetTime(from, to, displayLocal);
    React.useEffect(function () {
        if (!firstRun.current) {
            setResetTime(false);
            inputStart.current.value = 0;
            inputEnd.current.value = 24;
            var newFrom = from.set({ hour: 0, minute: 0, second: 0 });
            setFrom(newFrom);
            var newto = to.set({ hour: 23, minute: 59, second: 0 });
            setTo(newto);
        }
        firstRun.current = false;
    }, [resetTime, displayLocal]);
    React.useEffect(function () {
        var VIEW_LIMIT = 96;
        var since = to.diff(from, ["months", "days", "hours"]);
        var sinceDays = to.diff(from, ["days"]);
        var sinceHours = to.diff(from, ["hours"]);
        var actions = [];
        actions.push("MONTHS");
        var lastDay = from.plus({ days: VIEW_LIMIT });
        if (since.months < 2) {
            actions.push("DAYS");
        }
        else if (to < lastDay) {
            actions.push("DAYS");
        }
        if (since.months === 0 && sinceHours.hours < VIEW_LIMIT) {
            actions.push("HOURS");
        }
        if (!actions.includes(displayLocal)) {
            if (sinceDays.days > VIEW_LIMIT) {
                setDisplayLocal("MONTHS");
            }
            else {
                setDisplayLocal("DAYS");
            }
        }
        setAllowedActions(actions);
    }, [from, to]);
    React.useEffect(function () {
        setFrom(props.from);
    }, [props.from]);
    React.useEffect(function () {
        setTo(props.to);
    }, [props.to]);
    function reset() {
        var start = luxon_1.DateTime.local();
        var end = luxon_1.DateTime.local();
        start = start.set({ hour: 0, minute: 0, second: 0 });
        setFrom(start);
        end = end.set({ hour: 23, minute: 59, second: 0 });
        setTo(end);
        setDisplayLocal("DAYS");
    }
    function cancel() {
        reset();
        props.closePicker();
    }
    return (React.createElement("div", null,
        React.createElement(dateAndTime_1.DateAndTime, { inputRef: inputStart, id: "start", label: strings.startDate, value: from, display: displayLocal, setDate: setFrom, setReset: setResetTime, enableTime: enableTime, archiveMode: false, archiveDataFrom: props.archiveDataFrom, callSummaryDataFrom: props.callSummaryDataFrom, pickerIsShowing: props.pickerIsShowing, showArchivedTooltip: props.showArchivedTooltip, language: props.language }),
        React.createElement(dateAndTime_1.DateAndTime, { inputRef: inputEnd, id: "end", label: strings.endDate, value: to, display: displayLocal, setDate: setTo, setReset: setResetTime, enableTime: enableTime, archiveMode: false, archiveDataFrom: props.archiveDataFrom, callSummaryDataFrom: props.callSummaryDataFrom, pickerIsShowing: props.pickerIsShowing, showArchivedTooltip: props.showArchivedTooltip, language: props.language }),
        React.createElement("div", { className: customDateRange_styles_1.labelRow },
            React.createElement("label", { className: customDateRange_styles_1.label }, strings.displayDataBy)),
        React.createElement("div", { className: customDateRange_styles_1.row },
            React.createElement(displayDataBy_1.DisplayDataBy, { allowedActions: allowedActions, current: displayLocal, setRange: setDisplayLocal, setReset: setResetTime, language: props.language })),
        validationReason && (React.createElement("p", { className: customDateRange_styles_1.error, id: "time-validation-error" },
            strings.validationMessage1,
            " ",
            validationReason,
            " ",
            strings.validationMessage2)),
        React.createElement("div", { className: customDateRange_styles_1.buttonRow },
            React.createElement(core_components_1.Button, { className: customDateRange_styles_1.applyButton, id: "apply-custom-date", onClick: applyRange }, strings.apply),
            React.createElement(core_components_1.Button, { className: customDateRange_styles_1.cancelButton, id: "cancel-custom-date", text: true, onClick: cancel }, strings.cancel))));
}
exports.CustomDateRange = CustomDateRange;
function canSetTime(from, to, displayRange) {
    var diff = from.diff(to, ["days"]);
    return diff.days <= 3 && displayRange === "HOURS";
}
